// extracted by mini-css-extract-plugin
export default {"ul":"Statistics_ul__xP8Wk","subTitle":"Statistics_subTitle__Gg0YV"};